import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import DonatePage from "@/views/DonateView.vue";
import AboutView from "@/views/AboutView.vue";
import ContactView from "@/views/ContactView.vue";
import PitchDream from "@/views/PitchDream.vue";
import OurImpact from "@/views/OurImpact.vue";
import ScholarshipView from "@/views/ScholarshipView.vue";

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes: [
        {
            path: "/",
            name: "HomeView",
            component: Home,
        },
        {
            path: "/about-us",
            name: "about-view",
            component: AboutView,
        },
        {
            path: "/contact-us",
            name: "contact-view",
            component: ContactView,
        },
        {
            path: "/donate",
            name: "donate-view",
            component: DonatePage,
        },
        {
            path: "/pitch-your-dream",
            name: "pitch-your-dream",
            component: PitchDream,
        },
        {
            path: "/our-impact",
            name: "our-impact",
            component: OurImpact,
        },
        {
            path: "/scholarship",
            name: "scholarship",
            component: ScholarshipView,
        },
    ],

});

export default router;